import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0934d8cb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0934d8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934d8cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0934d8cb')) {
      api.createRecord('0934d8cb', component.options)
    } else {
      api.reload('0934d8cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0934d8cb&scoped=true&", function () {
      api.rerender('0934d8cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/supplier-dynamic-data/index.vue"
export default component.exports